import { render, staticRenderFns } from "./CoverSettingView.vue?vue&type=template&id=e28f2b1e&scoped=true"
import script from "./CoverSettingView.vue?vue&type=script&lang=js"
export * from "./CoverSettingView.vue?vue&type=script&lang=js"
import style0 from "./CoverSettingView.vue?vue&type=style&index=0&id=e28f2b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28f2b1e",
  null
  
)

export default component.exports